import React from "react"
import * as Sentry from "@sentry/react"
import MustacheEditor from "../../../components/MustacheEditor/MustacheEditor"
import {DefaultErr} from "../../../components/Err/Err"
import {DomainFilter} from "../../../components/DomainFilter/DomainFilter"

export const CreateEmailTemplate = ({
	newTemplateId,
	setNewTemplateId,
	error,
	handleCreateTemplate,
	newTemplateSubject,
	filteredDomains,
	setFilteredDomains,
}: {
	newTemplateId: string
	setNewTemplateId: (newTemplateId: string) => void
	error: string | null
	handleCreateTemplate: (htmlContent: string, subject?: string, samples?: string) => void
	newTemplateSubject: string
	filteredDomains: string[]
	setFilteredDomains: (filteredDomains: string[]) => void
}) => {
	return (
		<div className="email-template-editor-container">
			<div className="email-template-editor-header">
				<h2>Create New Email Template</h2>
				<div className="template-form-fields">
					<div className="form-field flex-75">
						<label htmlFor="templateId">Template ID</label>
						<input
							type="text"
							id="templateId"
							value={newTemplateId}
							onChange={(e) => setNewTemplateId(e.target.value)}
							placeholder="Enter a unique template ID"
							required
							pattern="[a-zA-Z0-9_\-.]+"
							title="Only letters, numbers, underscores, hyphens, and dots are allowed"
						/>
					</div>
					<div className="form-field flex-25">
						<label htmlFor="templateId">Domain</label>
						<DomainFilter statuses={filteredDomains} setStatuses={setFilteredDomains} singleOption />
					</div>
				</div>
				{error && <div className="error-message">{error}</div>}
			</div>
			<Sentry.ErrorBoundary fallback={<DefaultErr />}>
				<MustacheEditor
					initialHtml=""
					onSave={handleCreateTemplate}
					initialSubject={newTemplateSubject}
					showSubjectField={true}
				/>
			</Sentry.ErrorBoundary>
		</div>
	)
}
